/* eslint-disable @typescript-eslint/no-explicit-any */

import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'
import type { TransactionDetailsResponse, TransactionNotesResponse } from '@/api/typings/transaction.typing'

export interface AddTransactionNotePayload {
  content: string
}

export interface User {
  id: number
  uuid: string
  fullName: string
  email: string
  mobile: string | null
  succeedTransaction: number
  status: string
  createdAt: string
  updatedAt: string
}

export interface UserDiscount {
  id: number
  pid: number
  code: string
  title: string
  rate: number
  status: string
  status_type: string
  isUsed: boolean
  isExpired: boolean
  createdAt: string
  last_used_at: string | null
  expiry_date: string | null
  credit_type: string
  description: string
  transaction: any
  requisition: any
  offer: any
  discount_user: any
  type: { id: number; title: string; titleFa: string }
  currency: Array<{ id: string; titleFa: string; titleEn: string | null }>
  usage_count: number
  volume_limit: number
  user: any[]
}

export interface UpdateTransactionPayload {
  buyer: string
  seller: string
  amount: number
  exchange_rate?: number
  buyer_bank_account?: string | null
  buyer_source_bank_account?: string | null
  buyer_paypal_bank_account?: string | null
  buyer_revolut_bank_account?: string | null
  buyer_transfer_methods?: string[]
  buyer_discount?: string | null
  seller_bank_account?: string | null
  seller_bank_account_country?: string | null
  seller_transfer_methods?: string[]
  seller_discount?: string | null
  status?: string
}

export function getTransactionDetailsAction(uuid: string): Promise<ApiResponse<TransactionDetailsResponse>> {
  const url = `/transactions/${uuid}`
  return api.get<ApiResponse<TransactionDetailsResponse>>(url)
}

export function getTransactionNotesAction(uuid: string): Promise<ApiResponse<TransactionNotesResponse[]>> {
  const url = `/transactions/${uuid}/notes`
  return api.get<ApiResponse<TransactionNotesResponse[]>>(url)
}

export function addTransactionNoteAction(
  transactionId: string,
  payload: AddTransactionNotePayload
): Promise<ApiResponse<any>> {
  const url = `/transactions/${transactionId}/notes`

  return api.post<ApiResponse<any>>(url, { ...payload })
}

export function getBuyerPaymentAction(uuid: string): Promise<ApiResponse<any>> {
  const url = `/transactions/${uuid}/buyer-payment`
  return api.get<ApiResponse<any>>(url)
}

export interface PrintTransactionResponse {
  pdf_path: string
}

export function printTransactionAction(uuid: string): Promise<PrintTransactionResponse> {
  const url = `/transactions/${uuid}/print`
  return api.get<PrintTransactionResponse>(url)
}

export function registerSettlementReceiptAutoAction(uuid: string): Promise<ApiResponse<any>> {
  const url = `/transactions/${uuid}/register-settlement-receipt-auto`
  return api.post<ApiResponse<any>>(url)
}

export function getUsersAction(page: number = 1): Promise<ApiResponse<User[]>> {
  const url = `/users?page=${page}`
  return api.get<ApiResponse<User[]>>(url)
}

export function getAllUsersAction(): Promise<ApiResponse<User[]>> {
  return api.get<ApiResponse<User[]>>('/users/all')
}

export function getUserDiscountsAction(userUuid: string): Promise<ApiResponse<UserDiscount[]>> {
  const url = `/discounts/users/unused/${userUuid}`
  return api.get<ApiResponse<UserDiscount[]>>(url)
}

export function editTransactionAction(
  transactionId: string,
  payload: UpdateTransactionPayload
): Promise<ApiResponse<any>> {
  const url = `/transactions/${transactionId}`
  return api.put<ApiResponse<any>>(url, { ...payload })
}

export function getUserUnusedDiscountsForTransactionAction(
  userUuid: string,
  usedDiscount: string | number | null = null
): Promise<ApiResponse<UserDiscount[]>> {
  const url =
    usedDiscount !== null
      ? `/discounts/users/unused/${userUuid}/${usedDiscount}`
      : `/discounts/users/unused/${userUuid}`

  return api.get<ApiResponse<UserDiscount[]>>(url)
}
